import React from "react";
import { FormattedMessage } from "react-intl";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "name",
        name: <FormattedMessage id="user.name" />,
        sortable: true,
    },
    {
        field: "email",
        name: <FormattedMessage id="user.email" />,
        sortable: true,
    },
    {
        field: "updatedAt",
        dataType: "date",
        name: <FormattedMessage id="user.last-login" />,
        sortable: true,
    },
    {
        field: "createdAt",
        dataType: "date",
        name: <FormattedMessage id="user.created-at" />,
        sortable: true,
    },
    {
        field: "creatorId",
        name: <FormattedMessage id="user.creator.id" />,
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="user.creator.email" />,
        sortable: false,
    },
    {
        field: "creatorType",
        name: <FormattedMessage id="user.creator.type" />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
